import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  Popover,
  PopoverTrigger,
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "../../../../components";
import { LeadButton, type LeadButtonProps } from "./LeadButton";
import { TemperatureIcon } from "./icon";
import { TemperatureMenu } from "./menu";
import { faEye } from "@fortawesome/free-regular-svg-icons";
import { TooltipProvider } from "@radix-ui/react-tooltip";

interface Props extends LeadButtonProps {
  profileLinkId: string;
}
let link = `${window.location.origin}/p/`;

export const LeadOpenLinkButton = ({ profileLinkId, ...props }: Props) => (
  <LeadButton {...props} tooltipText="View Profile Version">
    <div
      className="w-9 h-9 p-2 relative shrink-0"
      onClick={() => {
        window.open(link + `${profileLinkId}`, "_blank");
      }}
    >
      <div>
        <FontAwesomeIcon
          width={20}
          height={20}
          icon={faEye}
          className="w-5 h-5"
        />
      </div>
    </div>
  </LeadButton>
);
